module.exports = __webpack_public_path__ + "2acb60f2/img/file-icon.c085e21e.svg";